import React from 'react'
import classes from 'classnames'

export default class Share extends React.Component {
  constructor(props) {
    super(props)
    this.state = { copied: false }
    this.handleCopy = this.handleCopy.bind(this)
  }

  handleCopy() {
    const url = window.location.href
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => {
        this.setState({ copied: true })
        setTimeout(() => this.setState({ copied: false }), 2000)
      })
    } else {
      var textarea = document.createElement('textarea')
      textarea.value = url
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.setState({ copied: true })
      setTimeout(() => this.setState({ copied: false }), 2000)
    }
  }

  render() {
    const { isAbsolute, className = 'Sidebar__share' } = this.props
    return (
      <div className={classes(className, { 'Sidebar__share_absolute': isAbsolute })}>
        <div className='Sidebar__share-body'>
          <span className='Link Link_light Link_single' onClick={this.handleCopy} style={{ cursor: 'pointer' }}>
            {this.state.copied ? 'Скопировано!' : 'Копировать ссылку'}
          </span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/Share.jsx